import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import useBrandGroupPublication from '@hooks/useBrandGroupPublication'
import useBrandGroupPublications from '@hooks/useBrandGroupPublications'

import BrandGroupListItem from './components/BrandGroupListItem'

const buildPageFilterFields = () => {
  const boxProps = {
    marginBottom: 16,
  }

  return [
    {
      component: 'EntitySelector',
      componentProps: {
        boxProps,
        entityKey: 'brands',
      },
      key: 'brand_id',
    },
  ]
}

const BrandGroups = (props: {publicationId: number}) => {
  const { publicationId } = props

  const filterPayload = useFilters()
  const { pageFilters } = filterPayload

  const brandGroupPublicationsPayload = useBrandGroupPublications({
    filters: { publication_id: publicationId, ...pageFilters },
    performHttpRequests: !!publicationId,
    requestOptions: {
      include_brand_group_brand: true,
      include_brand_group_publication_brand_group: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredBrandGroupPublications,
    filteredBrandGroupPublicationsCount,
    hasFilteredBrandGroupPublications,
    loading,
  } = brandGroupPublicationsPayload

  const brandGroupPublicationPayload = useBrandGroupPublication({ publication_id: publicationId })

  const {
    callbacks: {
      addBrandGroupPublication,
    },
  } = brandGroupPublicationPayload

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-brand-groups' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Brand Groups"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && hasFilteredBrandGroupPublications && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection flexDirection="column">
          {filteredBrandGroupPublications.map(brandGroupPublication => (
            <BrandGroupListItem
              key={brandGroupPublication.id}
              brandGroupPublication={brandGroupPublication}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      {!loading && !hasFilteredBrandGroupPublications && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Brand Groups Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please change your filters or add a brand group below
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{
          borderTop: loading ? 'none' : '1px solid',
          flexDirection: ['column', 'row'],
        }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredBrandGroupPublicationsCount}
        loading={loading}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          marginLeft="auto"
          onClick={() => addBrandGroupPublication()}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Brand Group
        </Button>
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

export default BrandGroups
